/**
 * Renders one of three states for a list/grid: loading skeleton, empty state, or children.
 * Replaces nested ternaries: `loading ? skeleton : items.length === 0 ? empty : list`.
 *
 * Usage:
 *   <ListState loading={loading} empty={items.length === 0} skeleton={<Skeleton/>} emptyState={<Empty/>}>
 *     {items.map(...)}
 *   </ListState>
 */
const ListState = ({ loading, empty, skeleton, emptyState, children }) => {
  if (loading) return skeleton;
  if (empty) return emptyState;
  return children;
};

export default ListState;
